import { createSelector } from 'reselect';
import { showSelector } from 'selectors/testTarget/offers/productDisclosures/show/showSelector';
import { isTestTargetReadySelector } from 'viewModel/selectors/testTarget/isTestTargetReadySelector';

const showProductDisclosuresSelector = createSelector(isTestTargetReadySelector, showSelector, (testReady, show) => testReady && show);

export { showProductDisclosuresSelector };
